import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { columns } from "./table-config";

export function Substitutions() {
	/** Hooks */
	const auth = useAuth();

	/** Query */
	const {
		data: substitutions,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["substitutions"],
		queryFn: async () => {
			if (!auth.user?.id) return null;
			const response = await client.users[":userId"].substitutions.$get({
				param: { userId: auth.user?.id },
			});
			const json = await responseHandler(response);
			return json.substitutions;
		},
		enabled: !!auth.user?.id,
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={guardArray(substitutions)}
				columns={columns}
				persistenceKey="substitutions-table"
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				menu={null}
				initialPinningState={{
					start: ["startDate", "endDate"],
					end: ["process-substitution-list", "actions"],
				}}
				getRowStyles={(row) => {
					if (moment().isAfter(row.original.endDate)) {
						return {
							className: "opacity-50 hover:opacity-100",
						};
					}
					return {};
				}}
			/>
		</ContentBox>
	);
}
